import { render, staticRenderFns } from "./SinglePracticeTooltip.vue?vue&type=template&id=40fc8835&scoped=true&"
import script from "./SinglePracticeTooltip.vue?vue&type=script&lang=js&"
export * from "./SinglePracticeTooltip.vue?vue&type=script&lang=js&"
import style0 from "./SinglePracticeTooltip.vue?vue&type=style&index=0&id=40fc8835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc8835",
  null
  
)

export default component.exports